module.exports = __webpack_public_path__ + "static/img/empty.e5097d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/empty.jpg
// module id = pP1+
// module chunks = 0